import {
  CALL_CENTER_DASHBOARD_LOADED,
  DELIVERY_CREATE_TOGGLE,
  EE_BUILDING_SESSION_FINISHED,
  EE_BUILDING_SESSION_SUCCEEDED,
  EE_SESSION_REFRESHED,
  EXCHANGE_TOKEN_FAILURE,
  EXCHANGE_TOKEN_SUCCESS,
  OPEN_DOOR,
  SET_CALL_CENTER_MODAL_TYPE,
  SET_CURRENT_CAMERA_ID,
} from '../actionConstants';

const defaultState = {
  residents: [],
  staff: [],
  deliveries: [],
  visitors: [],
  loading: false,
  deliveryTypes: [],
  units: [],
  deliveryCreate: false,
  building: {},
  door: {},
  selectedCameraId: null,
};

export default (state = defaultState, action) => {
  const { type, error, payload } = action ?? {};
  const data = payload?.data ?? {};
  switch (type) {
    case CALL_CENTER_DASHBOARD_LOADED:
    case EE_SESSION_REFRESHED:
    case OPEN_DOOR:
      return {
        ...state,
        loading: false,
        errors: error ? data : null,
        ...data,
      };
    case EE_BUILDING_SESSION_SUCCEEDED:
      return {
        ...state,
        loading: false,
        errors: error ? data : null,
        buildingId: action.buildingId,
        ...data,
      };
    case EE_BUILDING_SESSION_FINISHED:
      return defaultState;
    case EXCHANGE_TOKEN_SUCCESS:
    case EXCHANGE_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.err,
      };
    case DELIVERY_CREATE_TOGGLE:
      return {
        ...state,
        deliveryCreate: !state.deliveryCreate,
      };
    case SET_CALL_CENTER_MODAL_TYPE:
      return {
        ...state,
        modalType: action.modalType,
        defaultDeliveryType: action.defaultDeliveryType,
      };
    case SET_CURRENT_CAMERA_ID:
      return {
        ...state,
        selectedCameraId: action.id,
      };
    default:
      return state;
  }
};
